<template>
  <PageManager
    :iframe-target="link"
    page="default"
  />
</template>

<script>

import PageManager from "@/components/SideEditor/PageManager"

import { mapGetters } from "vuex"

export default {
  components: {
    PageManager,
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
    }),
  },
}

</script>
